import React from "react";
import PropTypes from "prop-types";
import {
    Drawer,
    Input,
    Button,
    Row,
    Col,
    Icon,
    Timeline,
    // Card,
    Tag
} from "antd";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchCaseNotes, createCaseNote, deleteCaseNote, retrieveCaseNote } from "store/actions";
import { STATE_STATUS } from "constants/index";
import { CaseNoteRecord } from "records/case-note-record";
import shortID from "uuid/v4";
import moment from "moment";
import SingleDayNotes from "./single-day-notes";

class CaseTaskNotes extends React.Component {
    state = {
        note: null
    };
    componentDidMount() {
        this.handleNotesFetch({});
    }

    componentDidUpdate(prevProps) {
        this.handleNotesFetch(prevProps);
    }

    handleNotesFetch = (prevProps) => {
        if (
            this.props.location.state &&
            this.props.location.state.case_notes &&
            this.props.location.state.case_notes.case_notes_view &&
            (!this.props.notesStatus ||
                this.props.notesStatus === STATE_STATUS.UNFETCHED)
        ) {
            this.props.fetchCaseNotes(this.props.caseId);
        }

        if(prevProps.notesCreating && !this.props.notesCreating) {
            this.setState({
                note: null
            });
        }
    }

    createCaseNote = () => {
        this.props.createCaseNote(
            this.props.caseId,
            this.props.stageId,
            shortID(),
            new CaseNoteRecord({
                user: this.props.user,
                case: this.props.caseId,
                stage: this.props.stage,
                notes: this.state.note,
                create_date: moment(),
                state_status: STATE_STATUS.CREATING
            })
        );
        // this.setState({
        //     note: null
        // });
    };
    hideCaseNote = () => {
        this.props.history.replace(this.props.location.pathname, {
            ...this.props.location.state,
            case_notes: {
                case_notes_view: false
            }
        });
    };

    deleteNote = (id) => {
        this.props.deleteCaseNote(this.props.caseId, [id]);
    }

    activateNote = (id) => {
        this.props.retrieveCaseNote(this.props.caseId, [id]);
    }

    onEdit = event =>
        this.setState({
            note: event.target.value
        });
    render() {
        return (
            <Drawer
                title={"Case Comments"}
                closable
                visible={
                    this.props.location.state &&
                    this.props.location.state.case_notes &&
                    this.props.location.state.case_notes.case_notes_view
                        ? true
                        : false
                }
                onClose={this.hideCaseNote}
                placement={"right"}
                width={"40vw"}
                footer={null}
            >
                <Row>
                    <Col span={24}>
                        <Row>
                            <Col
                                span={24}
                                style={{
                                    flexGrow: 1,
                                    minHeight: "65vh",
                                    maxHeight: "65vh",
                                    overflowY: "auto"
                                }}
                                className={"p-5"}
                            >
                                <Timeline>
                                    {this.props.notes &&
                                        this.props.notes
                                            .map((_, k) => (
                                                <Timeline.Item key={_.id}>
                                                    <div>
                                                        <Tag>
                                                            {k}
                                                        </Tag>
                                                    </div>
                                                    <SingleDayNotes 
                                                        notes={_}
                                                        deleteNote={this.deleteNote}
                                                        activateNote={this.activateNote}
                                                    />
                                                </Timeline.Item>
                                            ))
                                            .toList()}
                                </Timeline>
                            </Col>
                            <Col span={24} className={"mb-5 px-5 mt-10"}>
                                <Input.TextArea
                                    rows={4}
                                    style={{ width: "100%" }}
                                    placeholder={"Add case note..."}
                                    value={this.state.note}
                                    onChange={this.onEdit}
                                />
                            </Col>
                            <Col
                                span={24}
                                className={"px-5 d-flex justify-content-flex-end"}
                            >
                                <Button
                                    type={"primary"}
                                    block={true}
                                    onClick={this.createCaseNote}
                                    disabled={!(this.state.note)}
                                    loading={this.props.notesCreating}
                                >
                                    Submit <Icon type={"plus"} />
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Drawer>
        );
    }
}

CaseTaskNotes.propTypes = {
    caseId: PropTypes.number,
    companyId: PropTypes.number,
    user: PropTypes.object,
    stage: PropTypes.number,
    notesStatus: PropTypes.string,
    notes: PropTypes.object,
    fetchCaseNotes: PropTypes.func,
    createCaseNote: PropTypes.func,
    location: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
    stageId: PropTypes.string,
    deleteCaseNote: PropTypes.func,
    retrieveCaseNote: PropTypes.func,
    notesCreating: PropTypes.bool
};

const mapStateToProps = (state, props) => {
    const caseId =
        props.location.state &&
        props.location.state.case_notes &&
        props.location.state.case_notes.caseId;

    return {
        caseId,
        stageId: props.location.state &&
            props.location.state.case_notes &&
            props.location.state.case_notes.stageId,
        stage:
            props.location.state &&
            props.location.state.case_notes &&
            props.location.state.case_notes.stageId &&
            state.stages
                .get("data")
                .find(_ => _.id === props.location.state.case_notes.stageId),
        user: state.user.get("data"),
        notesStatus: state.caseNotes.getIn([caseId, "status"]),
        notes: state.caseNotes.getIn([caseId, "notes"]),
        notesCreating: state.caseNotes.getIn([caseId, "creating"], false)
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchCaseNotes,
            createCaseNote,
            deleteCaseNote,
            retrieveCaseNote
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CaseTaskNotes);
